import type { StorefrontStat } from "./types";

export function buildStorefrontStats(
  totalOffers: number,
  totalMerchants: number,
): StorefrontStat[] {
  return [
    {
      id: "total",
      label: "Available Offers",
      value: totalOffers,
      suffix: "+",
    },
    {
      id: "merchants",
      label: "Merchants",
      value: totalMerchants,
      suffix: "+",
    },
  ];
}
